
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integration-support",
      function () {
        return require("private-next-pages/integration-support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integration-support"])
      });
    }
  